import "./App.css";
import { Suspense } from "react";
import queryString from "query-string"
import {
	BrowserRouter as Router,
	Switch,
	Route,
  } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NavConfig from "components/NavConfig";
import Viewer from "components/Viewer";
import Settings from "components/Settings";
import Price from "components/Price";
import { CgSpinnerTwo } from "react-icons/cg";
import { useStore } from "store";
import { useWordpress } from "utils";
import Footer from "components/Footer";
import Loader from "components/Loader";

function App() {
	const { isLoading, isError, data, error } = useWordpress()
	const preload = useStore(state => state.preload)
 
    if (isLoading) {
    	return <div><Loader /></div>
    }
 
    if (isError) {
		return <span>Error: {error.message}</span>
    }

    const { rotation, size, theme, table, ring, control, powerSupply } = queryString.parse(window.location.search);

    if ( 
        rotation !== undefined ||
        size !== undefined ||
        theme !== undefined ||
        table !== undefined ||
        ring !== undefined ||
        control !== undefined ||
        powerSupply !== undefined
    ) {
        preload({ rotation, size, theme, table, ring, control, powerSupply, translations: data.translations })
    }
	// console.log(data)

	return (
		<Suspense fallback={<CgSpinnerTwo />}>
			<Router>
				<Switch>
					<Route render={() => (
						<div
							id="wrapper"
							className="container-fluid w-100 h-100 p-3 mx-auto flex-column"
						>
							<header className="masthead mb-auto">
								<div className="inner">
									<NavConfig data={data} />
								</div>
							</header>

							<main role="main" className="inner cover mt-1 mt-md-2 mt-lg-5">
								<div className="row">
									<div className="col-sm-7 col-xs-6">
										<Viewer />
									</div>
									<div className="col-sm-5 col-xs-6">
										<Settings data={data} />
										<Price data={data} />
									</div>
								</div>
							</main>

							<Footer />
							<ToastContainer />
						</div>
					)
				} />
				</Switch>
			</Router>
		</Suspense>
	);
}

export default App;
